import myzod, { Infer } from 'myzod'

export const JobMessageEventSchema = myzod.object({
  messageType: myzod.literal('FromWorker').or(myzod.literal('FromUser')),
  jobId: myzod.string().pattern(/^Job#/),
  messageId: myzod.string(),
  fromId: myzod.string().pattern(/^User#/),
  toId: myzod.string().pattern(/^User#/),
})

export type JobMessageEvent = Infer<typeof JobMessageEventSchema>
